import React from 'react';
import { SocialMediaShare } from '@components/SocialMediaShare';
import { quoteClickHelper } from '@helpers/quoteClickHelper';
import { Button } from '@components/Button';

interface SocialBarProps {
  hideRequestQuote: boolean;
  contactUsForm: { I18: Record<string, string> };
  shareTitle?: string;
}

export const SocialBar = ({
  shareTitle = '',
  hideRequestQuote = true,
  contactUsForm,
}: SocialBarProps) => {
  const requestForQuoteText = contactUsForm?.I18.RequestForQuote;

  return (
    <div className='c-headerbar-social'>
      <SocialMediaShare title={shareTitle} />
      {!hideRequestQuote && requestForQuoteText && (
        <Button
          size='medium'
          color='primary'
          text={requestForQuoteText}
          onClick={() => quoteClickHelper(contactUsForm)}
        />
      )}
    </div>
  );
};
